import React, { Component } from "react";
import ListGroup from "./navListGroup";
import { navLinks } from "../services/navLinkService";

class SideNav extends Component {
  state = {
    links: [],
    selectedLink: null,
  };

  async componentDidMount() {
    this.setState({ links: navLinks });

    const selected = {}
    this.setState({ selectedLink: selected });
  }

  handleLinkSelect = link => {
    this.setState({ selectedLink: link });
  };

  render () {
    return(
      <React.Fragment>
        <div className="shadow">
          <ListGroup
            items={this.state.links}
            selectedItem={this.state.selectedLink}
            onItemSelect={this.handleLinkSelect}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default SideNav;